import {
  BoxProps,
  Checkbox,
  Flex,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Spinner,
  useDisclosure,
} from "@chakra-ui/react";
import { useState } from "react";
import { FormattedMessage } from "react-intl";

interface AllCheckboxScenarioProps extends BoxProps {
  allChecked: boolean;
  allOnPageChecked: boolean;
  someOnPageChecked: boolean;
  noScenarios: boolean;
  checkAllOnPage: () => void;
  uncheckAllOnPage: () => void;
  checkAll: () => Promise<void>;
  uncheckAll: () => void;
}

export function AllCheckboxScenario({
  allChecked,
  allOnPageChecked,
  someOnPageChecked,
  noScenarios,
  checkAllOnPage,
  uncheckAllOnPage,
  checkAll,
  uncheckAll,
}: AllCheckboxScenarioProps) {
  const [isLoading, setLoading] = useState(false);
  const { isOpen, onOpen, onClose } = useDisclosure();
  return (
    <Menu isOpen={isOpen} placement="top" closeOnBlur={false}>
      <MenuButton
        onClick={() => !isLoading && (!allOnPageChecked ? checkAllOnPage() : uncheckAllOnPage())}
        onMouseEnter={onOpen}
        onMouseLeave={onClose}
      >
        <Flex h="full" alignItems="center" justifyContent="center">
          {isLoading ? (
            <Spinner size="sm" />
          ) : (
            <Checkbox
              alignItems="center"
              h="fit-content"
              cursor="pointer"
              isChecked={allOnPageChecked}
              isIndeterminate={!allOnPageChecked && someOnPageChecked}
              isDisabled={noScenarios}
            />
          )}
        </Flex>
      </MenuButton>
      <MenuList color="bij12_1.700" bgColor="white" onMouseEnter={onOpen} onMouseLeave={onClose}>
        <MenuItem
          fontWeight="normal"
          onClick={() => (!allOnPageChecked ? checkAllOnPage() : uncheckAllOnPage())}
        >
          {allOnPageChecked ? (
            <FormattedMessage
              id="listpage.numchecked.deselect.page"
              defaultMessage="Deselect all on page"
            />
          ) : (
            <FormattedMessage
              id="listpage.numchecked.select.page"
              defaultMessage="Select all on page"
            />
          )}
        </MenuItem>
        <MenuItem
          fontWeight="normal"
          onClick={async () => {
            if (allChecked) return uncheckAll();
            setLoading(true);
            await checkAll();
            setLoading(false);
          }}
        >
          {allChecked ? (
            <FormattedMessage id="listpage.numchecked.deselect.all" defaultMessage="Deselect all" />
          ) : (
            <FormattedMessage id="listpage.numchecked.select.all" defaultMessage="Select all" />
          )}
        </MenuItem>
      </MenuList>
    </Menu>
  );
}
